import { render, staticRenderFns } from "./codeBox.vue?vue&type=template&id=702dd154&scoped=true&"
import script from "./codeBox.vue?vue&type=script&lang=js&"
export * from "./codeBox.vue?vue&type=script&lang=js&"
import style0 from "./codeBox.vue?vue&type=style&index=0&id=702dd154&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702dd154",
  null
  
)

export default component.exports